module.exports = __webpack_public_path__ + "img/timer.8ed8fecb.svg";